import { OpusJobsGuard } from './opus-jobs.guard';

export const guards: any[] = [OpusJobsGuard];

export * from './opus-jobs.guard';
